import type { BetaPage } from './beta.types'

export const JIRA_BROWSE_URL = 'https://elevateos.atlassian.net/browse'

// Note: hidden-from-production pages, reachable by Administrators only. Remove an entry once
// the page launches for everyone.
export const BETA_PAGES: BetaPage[] = [
  {
    group: 'operations',
    id: 'reservations',
    name: 'Reservations (bookings, time blocks, amenities, details)',
    to: { path: '/reservations/bookings' },
  },
  {
    group: 'contacts',
    id: 'resident-profile-settings',
    name: 'Resident profile settings (show or hide client profile fields)',
    to: { path: '/dashboard/building-dashboard/resident-profile-settings' },
  },
]
